export default function Logo({ size = "default", showTagline = false }) {
  const sizes = {
    small: {
      icon: 32,
      text: "text-lg",
      tagline: "text-xs"
    },
    default: {
      icon: 44,
      text: "text-2xl",
      tagline: "text-sm"
    },
    large: {
      icon: 56,
      text: "text-3xl",
      tagline: "text-base"
    }
  };

  const s = sizes[size] || sizes.default;

  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center gap-3">
        {/* App Icon - Speech bubble with heart */}
        <div 
          className="flex items-center justify-center rounded-[22%] shadow-sm"
          style={{ 
            width: s.icon, 
            height: s.icon,
            backgroundColor: '#2F5BFF'
          }}
        >
          <svg 
            viewBox="0 0 64 64" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className="w-[75%] h-[75%]"
          >
            {/* Speech bubble */}
            <path 
              d="M32 6C16 6 6 17 6 28C6 34 9 40 15 44V54L27 47C29 47 30 48 32 48C48 48 58 37 58 28C58 17 48 6 32 6Z" 
              fill="white"
            />
            {/* Heart */}
            <path 
              d="M32 38L28 34C20 27 16 23 16 18C16 14 19 11 24 11C27 11 29 12 32 15C35 12 37 11 40 11C45 11 48 14 48 18C48 23 44 27 36 34L32 38Z" 
              fill="#2F5BFF"
            />
          </svg>
        </div>
        
        {/* Wordmark */}
        <span 
          className={`font-bold text-[#1F3A5F] tracking-tight ${s.text}`}
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          Say<span className="text-[#2F5BFF]">It</span>Better
        </span>
      </div>
      
      {/* Tagline */}
      {showTagline && (
        <p className={`text-[#6B7280] mt-2 text-center ${s.tagline}`}>
          Say what you mean — without damaging the relationship.
        </p>
      )}
    </div>
  );
}
